var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCostingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 152.3 39.1",
    style: {
      enableBackground: "new 0 0 152.3 39.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#008ACE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.2,29.5c-0.9,0.4-2.9,0.9-5.5,0.9c-7.5,0-11.3-4.7-11.3-10.8c0-7.3,5.2-11.4,11.8-11.4 c2.5,0,4.4,0.5,5.3,0.9l-1,3.9c-1-0.4-2.3-0.8-4.1-0.8c-3.8,0-6.8,2.3-6.8,7.1c0,4.3,2.6,7,6.9,7c1.5,0,3.1-0.3,4.1-0.7L58.2,29.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,30.4c-4.6,0-8.1-3-8.1-8.1c0-5.1,3.3-8.3,8.4-8.3c4.8,0,8,3.3,8,8C76.2,27.8,72.1,30.4,67.9,30.4 L67.9,30.4z M68,26.9c1.9,0,3.1-1.9,3.1-4.7c0-2.3-0.9-4.7-3.1-4.7c-2.3,0-3.2,2.4-3.2,4.7C64.8,24.9,65.9,26.9,68,26.9L68,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.1,25.8c0.9,0.5,2.8,1.2,4.2,1.2c1.5,0,2.1-0.5,2.1-1.3s-0.5-1.2-2.3-1.8c-3.3-1.1-4.5-2.8-4.5-4.7 c0-2.9,2.5-5.2,6.4-5.2c1.8,0,3.4,0.4,4.4,0.9l-0.8,3.3c-0.7-0.4-2.1-0.9-3.4-0.9c-1.2,0-1.9,0.5-1.9,1.2c0,0.7,0.6,1.2,2.5,1.8 c3,1,4.2,2.5,4.2,4.8c0,2.9-2.3,5.1-6.8,5.1c-2,0-3.9-0.5-5.1-1.1L79.1,25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.5,10.2v4.3h3.5V18h-3.5v5.7c0,1.9,0.5,2.8,1.9,2.8c0.7,0,1,0,1.4-0.1l0,3.7c-0.6,0.2-1.8,0.4-3.1,0.4 c-1.6,0-2.9-0.5-3.7-1.3c-0.9-0.9-1.3-2.4-1.3-4.6V18h-2.1v-3.6h2.1v-2.9L98.5,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.2,12.5c-1.5,0-2.5-1.1-2.5-2.4c0-1.4,1-2.4,2.6-2.4c1.6,0,2.5,1.1,2.6,2.4 C109.8,11.4,108.8,12.5,107.2,12.5L107.2,12.5z M104.8,30.1V14.4h4.9v15.6H104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.6,19.4c0-2-0.1-3.6-0.1-5h4.2l0.2,2.2h0.1c0.6-1,2.2-2.5,4.8-2.5c3.2,0,5.6,2.1,5.6,6.8v9.2h-4.9v-8.7 c0-2-0.7-3.4-2.5-3.4c-1.3,0-2.1,0.9-2.5,1.8c-0.1,0.3-0.2,0.8-0.2,1.2v9h-4.9V19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.1,27.8c0,3-0.6,5.5-2.4,7c-1.7,1.5-4,1.9-6.3,1.9c-2.1,0-4.2-0.4-5.6-1.2l1-3.7c1,0.6,2.7,1.2,4.5,1.2 c2.3,0,4.1-1.2,4.1-4.1v-1h-0.1c-0.9,1.3-2.4,2-4.2,2c-3.9,0-6.6-3.1-6.6-7.6c0-5.1,3.2-8.3,7.1-8.3c2.1,0,3.5,0.9,4.3,2.2h0.1 l0.2-1.9h4.2c-0.1,1-0.1,2.3-0.1,4.7V27.8z M142.3,20.8c0-0.3,0-0.6-0.1-0.9c-0.4-1.3-1.3-2.1-2.6-2.1c-1.8,0-3.2,1.6-3.2,4.4 c0,2.3,1.2,4.2,3.2,4.2c1.3,0,2.3-0.8,2.6-2c0.1-0.4,0.2-0.9,0.2-1.3V20.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1,18.5c-5.7,0-10.3,4.6-10.3,10.3s4.6,10.3,10.3,10.3c5.7,0,10.3-4.6,10.3-10.3c0,0,0,0,0,0 C34.4,23.1,29.8,18.5,24.1,18.5z M24.1,27.7c1.9,0,3.4,1.5,3.4,3.4c0,1.5-0.9,2.8-2.3,3.2v2.4h-2.3v-2.4c-1.4-0.5-2.3-1.8-2.3-3.2 h2.3c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1c-1.9,0-3.4-1.5-3.4-3.4c0-1.5,0.9-2.8,2.3-3.2v-2.5h2.3 v2.5c1.4,0.5,2.3,1.8,2.3,3.2h-2.3c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1C22.9,27.2,23.4,27.7,24.1,27.7L24.1,27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,31.6v2.9h12.9c-0.5-0.9-0.8-1.9-1.1-2.9H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.5,28.8c0-0.8,0.1-1.6,0.2-2.5H0v2.9h11.5C11.5,29.1,11.5,29,11.5,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.1,21.2H0v2.9h12.4C12.8,23,13.4,22.1,14.1,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0h18.3v3H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,10.6h18.3v3H0V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,5.3h18.3v3H4.6V5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,17.6v-1.7H0v3h16.4C17,18.4,17.7,18,18.3,17.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostingLogo);
export default __webpack_public_path__ + "static/media/costing-logo.4fb07c265c56d58fac45eebe18a0f6eb.svg";
export { ForwardRef as ReactComponent };